/** Base classes for a tag badge pill. */
export const TAG_BADGE_CLASS = 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium';

/** Returns background + text color classes for a tag badge based on the tag's color value. */
export function getTagBg(color: string | null | undefined): string {
  switch (color) {
    case 'primary': return 'bg-primary/15 text-warning';
    case 'warning': return 'bg-amber-500/15 text-warning';
    case 'success': return 'bg-emerald-500/15 text-success';
    case 'error': return 'bg-red-500/15 text-error';
    case 'purple': return 'bg-purple-500/15 text-purple-600';
    case 'pink': return 'bg-pink-500/15 text-pink-600';
    case 'sky': return 'bg-sky-500/15 text-sky-600';
    case 'black': return 'bg-gray-900/15 text-gray-900';
    default: return 'bg-primary/15 text-warning';
  }
}

/** Returns a hex color for SVG rendering of a tag. */
export function getTagHex(color: string | null | undefined): string {
  switch (color) {
    case 'primary': return '#a68a5b';
    case 'warning': return '#f59e0b';
    case 'success': return '#10b981';
    case 'error': return '#ef4444';
    case 'purple': return '#a855f7';
    case 'pink': return '#ec4899';
    case 'sky': return '#0ea5e9';
    case 'black': return '#111827';
    default: return '#a68a5b';
  }
}

/** Returns the dot/circle color class for a tag in dropdowns. */
export function getTagDot(color: string | null | undefined): string {
  switch (color) {
    case 'primary': return 'bg-primary';
    case 'warning': return 'bg-amber-500';
    case 'success': return 'bg-emerald-500';
    case 'error': return 'bg-red-500';
    case 'purple': return 'bg-purple-500';
    case 'pink': return 'bg-pink-500';
    case 'sky': return 'bg-sky-500';
    case 'black': return 'bg-gray-900';
    default: return 'bg-primary';
  }
}
